<at-header
  [menuControls]="sidenavPanelId"
  [menuExpanded]="sidenavOpen()"
  [showMenuBtn]="showSidenav()"
  (menuBtnClick)="toggleSidenav()"
>
  <ng-container headerActions>
    @if (isLoggedIn()) {
      <app-user-overlay-select />
    } @else {
      @if (isSignIn()) {
        <a atButton routerLink="/register" variant="outlined">
          {{ dictionary.signUpLink }}
        </a>
      } @else {
        <a atButton routerLink="/login" variant="outlined">
          {{ dictionary.signInLink }}
        </a>
      }
    }
  </ng-container>
</at-header>

@if (showSidenav()) {
  <at-sidenav class="header-sidenav" [panelId]="sidenavPanelId" [(open)]="sidenavOpen">
    <div class="sidenav-header">
      <a class="sidenav-logo" routerLink="/dashboard" (click)="toggleSidenav()">
        <img
          alt="AnotherTrip logo"
          class="header-logo-img"
          height="32"
          src="assets/icons/logo-at-light.svg"
          width="137"
        />
      </a>
      <button atButton type="button" variant="plain" (click)="toggleSidenav()">
        <at-icon>close</at-icon>
      </button>
    </div>
    <div class="sidenav-content">
      <app-dashboard-nav (itemClick)="toggleSidenav()" />
    </div>
  </at-sidenav>
}

@if (showLoadingBar()) {
  <div class="loading-bar"></div>
}
